import { FC } from "react";
import { Outlet } from "react-router";

const Root: FC = () => {
  return <><Outlet /></>;
}

export default Root;